import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";

const eur = (v) => Number(v || 0).toLocaleString("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 });

function Row({ label, value, sub, testid }) {
  return (
    <div className="flex items-baseline justify-between gap-4 py-2.5 border-b border-border last:border-0" data-testid={testid}>
      <div>
        <div className="text-sm font-semibold">{label}</div>
        {sub && <div className="text-[11px] text-muted-foreground">{sub}</div>}
      </div>
      <div className="font-heading font-bold text-lg whitespace-nowrap">{value}</div>
    </div>
  );
}

// Popup "Conversione": dettaglio calcolato sui soli lead esclusi Area Free e Area Rete.
export default function ConversionDialog({ open, onOpenChange, c }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="conversion-dialog">
        <DialogHeader>
          <DialogTitle>Venduto / Preventivato: {c.vend_prev_pct ?? 0}%</DialogTitle>
          <DialogDescription>Valore dei contratti firmati ÷ valore delle proposte inviate · conversione lead → contratto {c.pct ?? 0}%. Esclusi Area Free e Area Rete.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="rounded-lg border-2 border-primary px-4" data-testid="conv-section-pipeline">
            <Row label="Contratti" sub="Lead in fase Contratto (non archiviati)" value={c.contratti ?? 0} testid="conv-contratti" />
            <Row label="Lead considerati" sub="Esclusi Area Free e Area Rete" value={c.lead ?? 0} testid="conv-lead" />
            <Row label="Contratti inviati" sub="Proposte con contratto inviate al cliente" value={c.preventivi_inviati ?? 0} testid="conv-preventivi" />
            <Row label="Firmati / Inviati" sub={`${c.firmati_su_inviati ?? 0} firmati su ${c.preventivi_inviati ?? 0} inviati`}
              value={c.preventivi_inviati ? `${((100 * (c.firmati_su_inviati || 0)) / c.preventivi_inviati).toFixed(1)}%` : "—"} testid="conv-firmati-ratio" />
          </div>
          <div className="rounded-lg border-2 border-primary px-4" data-testid="conv-section-valore">
            <Row label="Venduto" sub="Valore dei contratti firmati (fase Contratto o contratto accettato)" value={eur(c.venduto)} testid="conv-venduto" />
            <Row label="Preventivato" sub="Valore delle proposte inviate al cliente" value={eur(c.preventivato)} testid="conv-preventivato" />
            <Row label="Venduto / Preventivato" sub="Quota del valore proposto trasformata in contratti firmati" value={c.preventivato ? `${c.vend_prev_pct}%` : "—"} testid="conv-ratio" />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
